/**
 * Frases rotativas del hero de Compartir. El mensaje fijo aburre; estas rotan con
 * fade para mantener energía. 20 frases premium en 4 idiomas (curadas por panel de
 * copy). Foco: FOMO positivo, acción + ganancia, sin prometer ganancias garantizadas.
 */
import i18n from '../languages.js';

const FRASES = [
    { es: 'Tu link, tu plata 💸', pt: 'Seu link, seu dinheiro 💸', en: 'Your link, your cash 💸', ru: 'Твоя ссылка — твои деньги 💸' },
    { es: 'Ellos juegan, vos cobrás 💰', pt: 'Eles jogam, você fatura 💰', en: 'They play, you cash in 💰', ru: 'Они играют — ты получаешь 💰' },
    { es: 'Cada jugada te paga 🔥', pt: 'Cada aposta te paga 🔥', en: 'Every play pays you 🔥', ru: 'Каждая ставка платит тебе 🔥' },
    { es: 'Compartí. La plata entra 💸', pt: 'Compartilhe. O dinheiro entra 💸', en: 'Share. The money rolls in 💸', ru: 'Делись. Деньги идут 💸' },
    { es: 'Más compartís, más entra 🚀', pt: 'Quanto mais compartilha, mais entra 🚀', en: 'Share more, earn more 🚀', ru: 'Больше делишься — больше капает 🚀' },
    { es: 'Tu comisión nunca para ⚡', pt: 'Sua comissão não para ⚡', en: 'Your commission never stops ⚡', ru: 'Твоя комиссия не спит ⚡' },
    { es: 'Tu gente juega, vos ganás 🚀', pt: 'Sua galera joga, você ganha 🚀', en: 'Your people play, you earn 🚀', ru: 'Твои играют — ты зарабатываешь 🚀' },
    { es: 'Compartir es facturar 💰', pt: 'Compartilhar é faturar 💰', en: 'Sharing means earning 💰', ru: 'Делиться — значит зарабатывать 💰' },
    { es: 'Tu link no descansa 🔥', pt: 'Seu link não para 🔥', en: 'Your link never sleeps 🔥', ru: 'Твоя ссылка не спит 🔥' },
    { es: 'Soltá el link y arrancá 🚀', pt: 'Solta o link e bora 🚀', en: 'Drop the link and go 🚀', ru: 'Кидай ссылку и погнали 🚀' },
    { es: 'Compartí. Que la rueda gire ⚡', pt: 'Compartilhe. Deixa a roda girar ⚡', en: 'Share it. Let the wheel spin ⚡', ru: 'Делись. Пусть колесо крутится ⚡' },
    { es: 'Un link que te rinde 💸', pt: 'Um link que rende pra você 💸', en: 'A link that pays off 💸', ru: 'Ссылка, которая приносит деньги 💸' },
    { es: 'Hoy compartís, hoy ganás 🔥', pt: 'Compartilhou hoje, ganhou hoje 🔥', en: 'Share today, earn today 🔥', ru: 'Поделился сегодня — заработал сегодня 🔥' },
    { es: 'Convertí tu grupo en comisión 💸', pt: 'Transforme sua galera em comissão 💸', en: 'Turn your group into commission 💸', ru: 'Преврати свой чат в комиссию 💸' },
    { es: 'Tu red, tu ganancia 🏆', pt: 'Sua rede, seu lucro 🏆', en: 'Your network, your profit 🏆', ru: 'Твоя сеть — твоя прибыль 🏆' },
    { es: 'Más amigos jugando, más comisión 💰', pt: 'Mais amigos jogando, mais comissão 💰', en: 'More friends playing, more commission 💰', ru: 'Больше друзей в игре — больше комиссии 💰' },
    { es: 'Dale play a tu link 🏆', pt: 'Dá o play no seu link 🏆', en: 'Hit play on your link 🏆', ru: 'Жми play на своей ссылке 🏆' },
    { es: 'Acelerá. Tu comisión te espera ⚡', pt: 'Acelera. Sua comissão te espera ⚡', en: 'Speed up. Your cut is waiting ⚡', ru: 'Жми. Твоя комиссия ждёт ⚡' },
    { es: 'Armá tu red, sumá comisión 🔥', pt: 'Monte sua rede, fature junto 🔥', en: 'Build your crew, stack commission 🔥', ru: 'Собирай команду, копи комиссию 🔥' },
    { es: 'Junta a los tuyos. A girar ⚡', pt: 'Chama a galera. Bora girar ⚡', en: "Gather your crew. Let's spin ⚡", ru: 'Зови своих. Погнали крутить ⚡' },
];

function frase(i) {
    const f = FRASES[i % FRASES.length];
    const lang = (i18n && i18n.currentLanguage) || 'es';
    return f[lang] || f.es;
}

/**
 * Rota la frase del elemento `el` cada `intervalo` ms con fade. Arranca en una
 * frase al azar (variando por índice de entrada para no ser siempre la misma).
 * Devuelve un stop() para limpiar el timer.
 * @param {HTMLElement} el
 * @param {number} [intervalo]
 * @returns {{ stop:()=>void }}
 */
export function rotarFrases(el, intervalo = 6000) {
    if (!el) return { stop() {} };
    // Índice inicial pseudo-aleatorio sin Math.random (varía por minutos del reloj
    // del usuario — suficiente para que no sea siempre la #0).
    let i = (new Date().getMinutes() + new Date().getSeconds()) % FRASES.length;
    el.textContent = frase(i);

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return { stop() {} }; // sin animación: queda la primera frase

    const timer = setInterval(() => {
        // Auto-detenerse cuando el elemento sale del DOM (al cambiar de vista el
        // app hace surface.innerHTML=''). Evita un timer huérfano por cada visita
        // a Compartir (memory leak). isConnected es la forma barata de detectarlo.
        if (!el.isConnected) {
            clearInterval(timer);
            return;
        }
        el.style.opacity = '0';
        setTimeout(() => {
            if (!el.isConnected) return;
            i++;
            el.textContent = frase(i);
            el.style.opacity = '1';
        }, 400); // coincide con la transition opacity del CSS
    }, intervalo);

    return {
        stop() {
            clearInterval(timer);
        },
    };
}
